import { ADD_BOOKING, REMOVE_BOOKING } from "./actionTypes";

const initialState = [
//   {
//     id: 1,
//     from: "Dhaka",
//     to: "Chittagong",
//     date: "2021-10-10",
//     guests: 2,
//     ticketClass: "Economy",
//   },
];

const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BOOKING:
      return [...state, action.payload];
    case REMOVE_BOOKING:
      return state.filter((booking) => booking.id !== action.payload);
    default:
      return state;
  }
};

export default bookingReducer;
